<template>
  <div
    class="p-8 lg:p-12 border-b border-[#EDEDED]"
    :class="index % 2 ? 'md:pt-24 lg:pt-40' : 'md:border-r'"
  >
    <div class="aspect-[1.77/1]">
      <!-- Image size 1248*704 -->
      <img
        class="w-full h-full object-cover"
        :src="src"
        :alt="alt"
        loading="lazy"
      />
    </div>

    <div class="mt-2" v-if="alt">
      <h3 class="paragraph" v-text="alt"></h3>
    </div>
  </div>
</template>

<script>
export default {
  name: 'galleryItem',
  props: {
    index: {
      type: Number,
      // required: true,
    },
    src: {
      type: String,
      // required: true,
    },
    alt: {
      type: String,
      // required: false,
    },
  },
}
</script>
